import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface SelectCreatorTypeProps {
  value: string;
  onChange: (value: string) => void;
}

const SelectCreatorType = ({ value, onChange }: SelectCreatorTypeProps) => (
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <InputLabel>Creator Type</InputLabel>
    <Select
      id="creator-type"
      name="creator-type"
      value={value}
      label="Creator Type"
      onChange={(event) => onChange(event.target.value)}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="brand">Brand Owned</MenuItem>
      <MenuItem value="kol">KOL</MenuItem>
      <MenuItem value="ugc">UGC</MenuItem>
    </Select>
  </FormControl>
);

export default SelectCreatorType;
